import i18n from "../../services/localization-service/i18n";
import { eLynxObjectTypeEnum } from "../enums/eLynxObjectType";
import { IKeyValuePair } from "../models/KeyValuePair";



export function getObjectTypeName(objectType?: eLynxObjectTypeEnum, plural?: boolean, lowerCase?: boolean): string {

    let name = '';


    switch (objectType) {

        case eLynxObjectTypeEnum.Attribute:
            name = plural
                ? i18n.t("objectTypeNames.attributes")
                : i18n.t("objectTypeNames.attribute");
            break;

        case eLynxObjectTypeEnum.TrendConfiguration:
            //case eLynxObjectTypeEnum.TrendConfiguration2:
            name = plural
                ? i18n.t("objectTypeNames.trendConfigurations")
                : i18n.t("objectTypeNames.trendConfiguration");
            break;

        case eLynxObjectTypeEnum.PageConfiguration:
            name = plural
                ? i18n.t("objectTypeNames.pageConfigurations")
                : i18n.t("objectTypeNames.pageConfiguration");
            break;


        case eLynxObjectTypeEnum.SetPoint:
            name = plural
                ? i18n.t("objectTypeNames.setpoints")
                : i18n.t("objectTypeNames.setpoint");
            break;

        case eLynxObjectTypeEnum.Group:
            name = plural
                ? i18n.t("objectTypeNames.groups")
                : i18n.t("objectTypeNames.group");
            break;

        case eLynxObjectTypeEnum.Device:
            name = plural
                ? i18n.t("objectTypeNames.devices")
                : i18n.t("objectTypeNames.device");
            break;

        case eLynxObjectTypeEnum.Tank:
            name = plural
                ? i18n.t("objectTypeNames.tanks")
                : i18n.t("objectTypeNames.tank");
            break;

        case eLynxObjectTypeEnum.Well:
            name = plural
                ? i18n.t("objectTypeNames.wells")
                : i18n.t("objectTypeNames.well");
            break;

        case eLynxObjectTypeEnum.Tag:
            //case eLynxObjectTypeEnum.TagValue:
            name = plural
                ? i18n.t("objectTypeNames.tags")
                : i18n.t("objectTypeNames.tag");
            break;

        case eLynxObjectTypeEnum.TankBattery:
            name = plural
                ? i18n.t("objectTypeNames.tankBatteries")
                : i18n.t("objectTypeNames.tankBattery");
            break;

        case eLynxObjectTypeEnum.Memo:
            name = plural
                ? i18n.t("objectTypeNames.memos")
                : i18n.t("objectTypeNames.memo");
            break;

        case eLynxObjectTypeEnum.MemoAutoText:
            name = i18n.t("objectTypeNames.memoAutoText");
            break;

        case eLynxObjectTypeEnum.AttributeValueOption:
            name = i18n.t("objectTypeNames.attributeValueOption");
            break;

        case eLynxObjectTypeEnum.Formulae:
            name = i18n.t("objectTypeNames.formulae");
            break;

        case eLynxObjectTypeEnum.RulesEngineRuleInstance:
            name = i18n.t("objectTypeNames.rulesEngineInstance");
            break;

        case eLynxObjectTypeEnum.RulesEngineRule:
            name = i18n.t("objectTypeNames.rulesEngineRule");
            break;

        case eLynxObjectTypeEnum.Accounting:
            //case eLynxObjectTypeEnum.AccountingingData:
            name = i18n.t("objectTypeNames.accounting");
            break;

        case eLynxObjectTypeEnum.DataFileImportConfiguration:
            name = i18n.t("objectTypeNames.dataFileImportConfig");
            break;

        case eLynxObjectTypeEnum.ObjectTemplate:
            name = i18n.t("objectTypeNames.objectTemplate");
            break;

        case eLynxObjectTypeEnum.PlatformObject:
            name = i18n.t("objectTypeNames.platformObject");
            break;

        case eLynxObjectTypeEnum.PollingServerCommunicationsObject:
            name = i18n.t("objectTypeNames.pollingServerCommunicationsObject");
            break;

        case eLynxObjectTypeEnum.PollingServerProtocolObject:
            name = i18n.t("objectTypeNames.pollingServerProtocolObject");
            break;

        case eLynxObjectTypeEnum.User:
            name = plural
                ? i18n.t("objectTypeNames.users")
                : i18n.t("objectTypeNames.user");
            break;

        case eLynxObjectTypeEnum.Role:
            name = plural
                ? i18n.t("objectTypeNames.roles")
                : i18n.t("objectTypeNames.role");
            break;

        case eLynxObjectTypeEnum.Recipient:
            name = plural
                ? i18n.t("objectTypeNames.recipients")
                : i18n.t("objectTypeNames.recipient");
            break;

        case eLynxObjectTypeEnum.NotificationList:
            name = plural
                ? i18n.t("objectTypeNames.notificationLists")
                : i18n.t("objectTypeNames.notificationList");
            break;

        case eLynxObjectTypeEnum.AlarmSchedule:
            name = plural
                ? i18n.t("objectTypeNames.alarmSchedules")
                : i18n.t("objectTypeNames.alarmSchedule");
            break;

        case eLynxObjectTypeEnum.AlarmScheme:
            name = plural
                ? i18n.t("objectTypeNames.alarmSchemes")
                : i18n.t("objectTypeNames.alarmScheme");
            break;

        case eLynxObjectTypeEnum.None:
            name = i18n.t("objectTypeNames.none");
            break;

        case eLynxObjectTypeEnum.CommunicationDevice:
            name = plural
                ? i18n.t("objectTypeNames.communicationDevices")
                : i18n.t("objectTypeNames.communicationDevice");
            break;

        case eLynxObjectTypeEnum.Customer:
            name = plural
                ? i18n.t("objectTypeNames.customers")
                : i18n.t("objectTypeNames.customer");
            break;

        case eLynxObjectTypeEnum.Organization:
            name = plural
                ? i18n.t("objectTypeNames.organizations")
                : i18n.t("objectTypeNames.organization");
            break;

        case eLynxObjectTypeEnum.DRCConfigInstance:
            name = plural
                ? i18n.t("objectTypeNames.drcConfigInstances")
                : i18n.t("objectTypeNames.drcConfigInstance");
            break;

        case eLynxObjectTypeEnum.DRCConfigInstanceCollection:
            name = plural
                ? i18n.t("objectTypeNames.drcConfigInstanceCollections")
                : i18n.t("objectTypeNames.drcConfigInstanceCollection");
            break;

        case eLynxObjectTypeEnum.GroupTrendConfiguration:
            name = plural
                ? i18n.t("objectTypeNames.groupTrendConfigurations")
                : i18n.t("objectTypeNames.groupTrendConfiguration");
            break;

        case eLynxObjectTypeEnum.SummaryListingPage:
            name = plural
                ? i18n.t("objectTypeNames.summaryListingPages")
                : i18n.t("objectTypeNames.summaryListingPage");
            break;

        case eLynxObjectTypeEnum.LookupList:
            name = plural
                ? i18n.t("objectTypeNames.lookupLists")
                : i18n.t("objectTypeNames.lookupList");
            break;

        case eLynxObjectTypeEnum.LookupListText:
            name = plural
                ? i18n.t("objectTypeNames.lookupListTexts")
                : i18n.t("objectTypeNames.lookupListText");
            break;

        case eLynxObjectTypeEnum.Facility:
            name = plural
                ? i18n.t("objectTypeNames.facilities")
                : i18n.t("objectTypeNames.facility");
            break;

        case eLynxObjectTypeEnum.Dynacard:
            name = plural
                ? i18n.t("objectTypeNames.dynacards")
                : i18n.t("objectTypeNames.dynacard");
            break;

        case eLynxObjectTypeEnum.UnitSet:
            name = plural
                ? i18n.t("objectTypeNames.unitSets")
                : i18n.t("objectTypeNames.unitSet");
            break;

        case eLynxObjectTypeEnum.TankPad:
            name = plural
                ? i18n.t("objectTypeNames.tankPads")
                : i18n.t("objectTypeNames.tankPad");
            break;

        case eLynxObjectTypeEnum.UserList:
            name = i18n.t("objectTypeNames.userList");
            break;

        case eLynxObjectTypeEnum.DRCExtendedConfig:
            name = i18n.t("objectTypeNames.drcExtendedConfig");
            break;

        case eLynxObjectTypeEnum.ObjectRelationship:
            name = i18n.t("objectTypeNames.objectRelationship");
            break;

        case eLynxObjectTypeEnum.TagThreadType:
            name = i18n.t("objectTypeNames.tagThreadType");
            break;

        case eLynxObjectTypeEnum.ApplicationType:
            name = i18n.t("objectTypeNames.applicationType");
            break;

        // unsupported types
        case eLynxObjectTypeEnum.Issue:
        case eLynxObjectTypeEnum.AnalyticsConfigurationObjectBridge:
        case eLynxObjectTypeEnum.InjectionPattern:
        case eLynxObjectTypeEnum.InjectionPatternPageConfiguration:
        case eLynxObjectTypeEnum.AnalyticsModelVersion:
            break;


        case eLynxObjectTypeEnum.Basin:
            name = i18n.t("objectTypeNames.basin");
            break;

        case eLynxObjectTypeEnum.Field:
            name = i18n.t("objectTypeNames.field");
            break;

        case eLynxObjectTypeEnum.Pad:
            name = i18n.t("objectTypeNames.pad");
            break;

        case eLynxObjectTypeEnum.DeviceConfiguration:
            name = i18n.t("objectTypeNames.deviceConfiguration");
            break;

        default:
            //console.log(`unknown object type: ${objectType}`);
            //name = "Unknown";
            name = objectType ? eLynxObjectTypeEnum[objectType] : "Unknown";
            break;
    }

    return lowerCase
        ? name.toLocaleLowerCase()
        : name;
}


// export function getObjectTypeName(objectType?: eLynxObjectTypeEnum, plural?: boolean, lowerCase?: boolean): string {
//     let name = objectType === eLynxObjectTypeEnum.Device
//         ? plural
//             ? i18n.t("objectTypeNames.devices")
//             : i18n.t("objectTypeNames.device")
//         : objectType === eLynxObjectTypeEnum.Group
//             ? plural
//                 ? i18n.t("objectTypeNames.groups")
//                 : i18n.t("objectTypeNames.group")

//             : objectType === eLynxObjectTypeEnum.Well
//                 ? plural
//                     ? i18n.t("objectTypeNames.wells")
//                     : i18n.t("objectTypeNames.well")

//                 : objectType === eLynxObjectTypeEnum.Tag
//                     ? plural
//                         ? i18n.t("objectTypeNames.tags")
//                         : i18n.t("objectTypeNames.tag")

//                     : objectType === eLynxObjectTypeEnum.Tank
//                         ? plural
//                             ? i18n.t("objectTypeNames.tanks")
//                             : i18n.t("objectTypeNames.tank")

//                         : objectType === eLynxObjectTypeEnum.TankBattery
//                             ? plural
//                                 ? i18n.t("objectTypeNames.tankBatteries")
//                                 : i18n.t("objectTypeNames.tankBattery")
//                             : 
//                             objectType === eLynxObjectTypeEnum.Memo 
//                                 ? plural 
//                                 ? i18n.t("objectTypeNames.memos")
//                                 : i18n.t("objectTypeNames.memo")
//                             :


//                             "Unknown";
//     return lowerCase
//         ? name.toLocaleLowerCase()
//         : name;
// }

export function getObjectTypes(): IKeyValuePair<eLynxObjectTypeEnum, string>[] {

    const data: IKeyValuePair<eLynxObjectTypeEnum, string>[] = [];

    Object.keys(eLynxObjectTypeEnum).forEach((o: any) => {
        //console.log(`o:${o} v: ${eLynxObjectTypeEnum[o]}`)
        if (!isNaN(o)) {
            data.push({
                Key: +o,
                Value: getObjectTypeName(+o)
            });
        }
    });


    return data.filter(o => o.Value !== '').sort((a, b) => (a.Value as string).localeCompare(b.Value as string));
}



